import React from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

const TAB_PATHS = {
  tasks: '/yandex/tracker/tasks',
  queues: '/yandex/tracker/queues',
} as const;

function YandexTrackerLayout(): React.ReactElement {
  const navigate = useNavigate();
  const location = useLocation();

  const currentTab = location.pathname.startsWith(TAB_PATHS.queues) ? 'queues' : 'tasks';

  const handleTabChange = (_: React.SyntheticEvent, value: 'tasks' | 'queues') => {
    navigate(TAB_PATHS[value]);
  };

  return (
    <Box
      sx={{
        height: '100%',
        minHeight: 0,
        maxHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        maxWidth: 900,
        width: '100%',
        margin: '0 auto',
        px: 2,
        pb: 2,
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexShrink: 0,
          py: 1.5,
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Typography variant="h5" fontWeight={600}>
          Яндекс Трекер
        </Typography>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          sx={{
            mt: 1,
            minHeight: 40,
            '& .MuiTab-root': { minHeight: 40, py: 1, textTransform: 'none' },
          }}
        >
          <Tab label="Задачи" value="tasks" />
          <Tab label="Очереди" value="queues" />
        </Tabs>
      </Box>
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          pt: 2,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}

export default YandexTrackerLayout;
